import React, { Component, PropTypes } from 'react';


export default class FestivalFloater extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    showFloater: true
  }

  handleCloseClick = (e) => {
    e.stopPropagation();
    this.setState({showFloater: false});
  }

  handleFloaterClick = (e) => {
    e.preventDefault();
    window.open('https://www.gofundme.com/bus-500-girls-to-girls039-festival', '_blank');
  }

  render() {

    let floater = '';
    if (this.state.showFloater) {
      floater = <div onClick={this.handleFloaterClick.bind(this)} className="site-wide-floater">
        <div onClick={this.handleCloseClick.bind(this)} className="close-wrapper">
          <i className="fa fa-times" aria-hidden="true"></i>
        </div>
        <div className="header-wrapper">

          <img src="/images/festival/go_fund_me.jpg" />
        </div>

        <div className="floater-copy">
          Donate to help bus 500 girls to the Girls' Festival!
        </div>
      </div>
    }

    return(
      <div>
        {floater}
      </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/components/festival/FestivalFloater.jsx